import { flow } from 'fp-ts/function';
import { createAction } from '@mews/framework';
import { ReservationGroup } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import prefix from '../prefix';
import parentSelector from '../selector';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'reservationGroups';

const RESERVATION_GROUPS_LOADED = prefix('RESERVATION_GROUPS_LOADED');
const RESERVATION_GROUP_LOADED = prefix('RESERVATION_GROUP_LOADED');

export const setReservationGroups = (reservationGroups: $TSFixMe) =>
    createAction(RESERVATION_GROUPS_LOADED, { entities: reservationGroups });
export const setReservationGroup = (reservationGroup: $TSFixMe) =>
    createAction(RESERVATION_GROUP_LOADED, reservationGroup);

export const reservationGroupsReducer = createEntitiesReducer({
    ADD_SUCCESS: RESERVATION_GROUP_LOADED,
    FETCH_SUCCESS: RESERVATION_GROUPS_LOADED,
});
export const [getReservationGroups, getReservationGroupsByIds, getReservationGroupsByOwnerId, getReservationGroup] =
    createBaseEntitySelectors<ApplicationState, ReservationGroup, typeof NAME>(parentSelector, NAME);

export const getReservationGroupName = flow(getReservationGroup, (group) => group?.name);
